import {useQuery} from '@tanstack/react-query'
import {useAuthUser} from 'react-auth-kit'
import {API} from 'src/feature/bite/domain'
import useRequestParams from 'src/feature/bite/hook/request'

const apiUrlRedeem = `${API}/Analytics`

export function useGetAnalytics(period: number = 1) {
  const {headers} = useRequestParams()

  const auth = useAuthUser()

  const userID = auth()?.id

  return useQuery(
    ['analytics', period],
    async () => {
      const Response = await Promise.all([
        await getMemberAnalytics(headers, userID, period),
        await getAverageAnalytics(headers, userID, period),
        await getRateAnalytics(headers, userID, period),
        await getPointAnalytics(headers, userID, period),
        await getRevenueTimeBandAnalytics(headers, userID, period),
        await getRevenueAnalytics(headers, userID, period),
        await getOrderAnalytics(headers, userID, period),
        await getTransactionAnalytics(headers, userID, period),
      ])

      const Data = {
        member: Response[0],
        average: Response[1],
        rate: Response[2],
        point: Response[3],
        revenueTimeBand: Response[4],
        revenue: Response[5],
        order: Response[6],
        transaction: Response[7],
      }

      return Data
    },
    {
      enabled: true,
      refetchOnWindowFocus: false,
      refetchOnMount: true,
      refetchOnReconnect: false,
      retry: false,
      cacheTime: 0,
      staleTime: 0,
      onSuccess: () => {},
      onError: (error) => {
        console.log(error)
      },
    }
  )
}

export const getMemberAnalytics = async (headers: any, userID: string, period: number) => {
  const reqBody = {
    language: headers.Language,
    userID,
    period,
  }

  const Response = await fetch(`${apiUrlRedeem}/GetMemberAnalytics`, {
    method: 'POST',
    headers,
    body: JSON.stringify(reqBody),
  })

  const Data = await Response.json()

  return Data.response
}

export const getAverageAnalytics = async (headers: any, userID: string, period: number) => {
  const reqBody = {
    userID,
    period,
    language: headers.Language,
  }

  const Response = await fetch(`${apiUrlRedeem}/GetAverageAnalytics`, {
    method: 'POST',
    headers,
    body: JSON.stringify(reqBody),
  })

  const Data = await Response.json()

  return Data.response
}

export const getRateAnalytics = async (headers: any, userID: string, period: number) => {
  const reqBody = {
    userID,
    period,
    language: headers.Language,
  }

  const Response = await fetch(`${apiUrlRedeem}/GetRateAnalytics`, {
    method: 'POST',
    headers,
    body: JSON.stringify(reqBody),
  })

  const Data = await Response.json()

  return Data.response
}

export const getPointAnalytics = async (headers: any, userID: string, period: number) => {
  const reqBody = {
    userID,
    period,
    language: headers.Language,
  }

  const Response = await fetch(`${apiUrlRedeem}/GetPointAnalytics`, {
    method: 'POST',
    headers,
    body: JSON.stringify(reqBody),
  })

  const Data = await Response.json()

  return Data.response
}

export const getRevenueTimeBandAnalytics = async (headers: any, userID: string, period: number) => {
  const reqBody = {
    userID,
    period,
    language: headers.Language,
  }

  const Response = await fetch(`${apiUrlRedeem}/GetRevenueTimeBandAnalytics`, {
    method: 'POST',
    headers,
    body: JSON.stringify(reqBody),
  })

  const Data = await Response.json()

  return Data.response
}

export const getRevenueAnalytics = async (headers: any, userID: string, period: number) => {
  const reqBody = {
    userID,
    period,
    language: headers.Language,
  }

  const Response = await fetch(`${apiUrlRedeem}/GetRevenueAnalytics`, {
    method: 'POST',
    headers,
    body: JSON.stringify(reqBody),
  })

  const Data = await Response.json()

  return Data.response
}

export const getOrderAnalytics = async (headers: any, userID: string, period: number) => {
  const reqBody = {
    userID,
    period,
    language: headers.Language,
  }

  const Response = await fetch(`${apiUrlRedeem}/GetOrderAnalytics`, {
    method: 'POST',
    headers,
    body: JSON.stringify(reqBody),
  })

  const Data = await Response.json()

  return Data.response
}

export const getTransactionAnalytics = async (headers: any, userID: string, period: number) => {
  const reqBody = {
    userID,
    period,
    language: headers.Language,
  }

  const Response = await fetch(`${apiUrlRedeem}/GetTransactionAnalytics`, {
    method: 'POST',
    headers,
    body: JSON.stringify(reqBody),
  })

  const Data = await Response.json()

  return Data.response
}
